import React from 'react';
import './Settings.css';

const Settings = () => {
  return (
    <div className="settings-page">
      <div className="page-header">
        <h1>Einstellungen</h1>
        <p>Konfiguration und Systemeinstellungen</p>
      </div>

      <div className="settings-grid">
        <div className="settings-card">
          <h3>Demo-Einstellungen</h3>
          <div className="setting-item">
            <label>Animations-Geschwindigkeit</label>
            <input type="range" min="1" max="10" defaultValue="3.3" disabled />
            <span className="setting-value">3.3 Sekunden</span>
          </div>
          <div className="setting-item">
            <label>Auto-Start</label>
            <input type="checkbox" defaultChecked disabled />
          </div>
        </div>

        <div className="settings-card">
          <h3>Benachrichtigungen</h3>
          <div className="setting-item">
            <label>Warnungen aktiviert</label>
            <input type="checkbox" defaultChecked disabled />
          </div>
          <div className="setting-item">
            <label>Kritische Meldungen</label>
            <input type="checkbox" defaultChecked disabled />
          </div>
        </div>

        <div className="settings-card">
          <h3>Darstellung</h3>
          <div className="setting-item">
            <label>Theme</label>
            <select disabled>
              <option>Dark Mode</option>
              <option>Light Mode</option>
            </select>
          </div>
          <div className="setting-item">
            <label>Sprache</label>
            <select disabled>
              <option>Deutsch</option>
              <option>English</option>
            </select>
          </div>
        </div>

        <div className="settings-card info-card">
          <h3>Über LEONIK Cristal Vision</h3>
          <p><strong>Version:</strong> 1.0.0 (Demo)</p>
          <p><strong>Entwickelt von:</strong> LEONIK · Data analysis and forecasting</p>
          <p><strong>Kontakt:</strong> info@leonik.de</p>
          <p><strong>Web:</strong> <a href="https://leonik.de" target="_blank" rel="noopener noreferrer">www.leonik.de</a></p>
        </div>
      </div>
    </div>
  );
};

export default Settings;
